<template>
    <div>
        <div class="row" v-if="products.length > 0">
            <h2 class="title col mt-0">Productos participantes</h2>
        </div>
        <div class="row" v-if="isLoading">
            <div class="col-12 text-center">
                <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
        </div>
        <div class="row" v-if="!isLoading && products.length > 0">
            <div @click="goToProduct(product)" class="col-6 col-sm-6 col-md-3 mb-4" v-for="(product, index) in OrdenedProducts" :key="index">
                <div class="card card-product-small" style="width: 100%">
                    <div class="promo-card-hd card-header text-center">
                        <img class="img-product-card" 
                            :src="`${product.producto_imagen.public_path}`"
                            :alt="product.producto_imagen.alt"
                            :width="93"
                            :height="60"/>
                    </div>
                    <div class="card-body text-center">
                        <p class="card-title mt-3 product-title-card pt-blue" style="font-size: 0.9em">{{ product.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data(){
        return{
            products: [],
            isLoading: false,
        }
    },
    mounted(){
        //this.getProducts();
    },
    watch:{
        $productsData: {
            handler: function (newValue) {
                if(newValue){
                    this.products = newValue;
                }
            },
            immediate: true
        },
    },
    methods:{
        getProducts(){
            this.isLoading = true;
            axios.get('/api/v1/content/stories?segment=2&attributes',{ headers: {
                'x-api-key': '9c6334a7-8215-46ff-8ec9-f442cdc43cac',
                'Content-Type': 'application/json'
            }}).then(res => { 
                this.products = res.data.data
                this.isLoading = false;
            }).catch(error => {
                console.error(error);
                this.isLoading = false;
            });
        },
        goToProduct(data){
            window.location.href = `/productos/${data.slug}`; 
        }
    },
    computed:{
        OrdenedProducts(){
            return this.products.sort((a, b) => a.order - b.order );
        }
    }
}
</script>